// 最新お役立ち資料 テキスト高さ
(() => {
	const texts = document.querySelectorAll(".document__txt");
	if (!texts.length) return;

	const setEqualHeight = () => {
		if (window.innerWidth < 769) {
			texts.forEach((el) => {
				el.style.height = "auto";
			});
			return;
		}

		let maxHeight = 0;

		texts.forEach((el) => {
			el.style.height = "auto";
		});

		texts.forEach((el) => {
			const h = el.offsetHeight;
			if (h > maxHeight) {
				maxHeight = h;
			}
		});

		texts.forEach((el) => {
			el.style.height = `${maxHeight}px`;
		});
	};

	setEqualHeight();
	window.addEventListener("resize", setEqualHeight);
})();

// 徹底した見える化サポート タイトル高さ
(() => {
	const texts = document.querySelectorAll(".support__head");
	if (!texts.length) return;

	const setEqualHeight = () => {
		if (window.innerWidth < 769) {
			texts.forEach((el) => {
				el.style.height = "auto";
			});
			return;
		}

		let maxHeight = 0;

		texts.forEach((el) => {
			el.style.height = "auto";
		});

		texts.forEach((el) => {
			const h = el.offsetHeight;
			if (h > maxHeight) {
				maxHeight = h;
			}
		});

		texts.forEach((el) => {
			el.style.height = `${maxHeight}px`;
		});
	};

	setEqualHeight();
	window.addEventListener("resize", setEqualHeight);
})();

// お取組みの流れ タイトル高さ
(() => {
	const texts = document.querySelectorAll(".flow__head");
	if (!texts.length) return;

	const setEqualHeight = () => {
		if (window.innerWidth < 769) {
			texts.forEach((el) => {
				el.style.height = "auto";
			});
			return;
		}

		let maxHeight = 0;

		texts.forEach((el) => {
			el.style.height = "auto";
		});

		texts.forEach((el) => {
			const h = el.offsetHeight;
			if (h > maxHeight) {
				maxHeight = h;
			}
		});

		texts.forEach((el) => {
			el.style.height = `${maxHeight}px`;
		});
	};

	setEqualHeight();
	window.addEventListener("resize", setEqualHeight);
})();

// よくあるご質問 開閉
(() => {
	const items = document.querySelectorAll(".faq__item");
	if (!items.length) return;

	items.forEach((item) => {
		const question = item.querySelector(".faq__question");
		const answer = item.querySelector(".faq__answer");
		if (!question || !answer) return;

		answer.style.height = "0";
		answer.style.overflow = "hidden";

		question.addEventListener("click", () => {
			const isOpen = item.classList.toggle("is-open");

			if (isOpen) {
				answer.style.height = answer.scrollHeight + "px";
			} else {
				answer.style.height = "0";
			}
		});
	});
})();

// 追従CTA
(() => {
	const followCta = document.querySelector(".followCta");
	const fv = document.querySelector(".fv");
	if (!followCta || !fv) return;

	const isSp = () => window.innerWidth <= 768;

	const onScroll = () => {
		if (!isSp()) {
			followCta.classList.remove("is-show");
			return;
		}

		const fvBottom = fv.getBoundingClientRect().bottom + window.scrollY;
		const scrollY = window.scrollY;
		const windowBottom = scrollY + window.innerHeight;
		const documentHeight = document.documentElement.scrollHeight;

		if (scrollY > fvBottom && windowBottom < documentHeight) {
			followCta.classList.add("is-show");
		} else {
			followCta.classList.remove("is-show");
		}
	};

	window.addEventListener("scroll", onScroll);
	window.addEventListener("resize", onScroll);
	onScroll();
})();
